import { PropsWithChildren } from 'react';

import { Card, Stack } from '@cast/design-system';

import { shadowDividerProps } from 'utils/theme';

import type { StackProps } from '@cast/design-system';

export const SummaryBox = ({
  children,
  ...props
}: PropsWithChildren<StackProps>) => {
  return (
    <Card sx={{ padding: '0' }}>
      <Stack
        display="grid"
        gridTemplateColumns="repeat(2, 1fr)"
        minHeight="100%"
        sx={{
          '& > *': {
            padding: '16px',
          },
          '& > :not(:first-of-type)': {
            position: 'relative',
            paddingLeft: '20px',
          },

          '& > :not(:first-of-type):after': {
            ...shadowDividerProps('vertical'),
            content: '""',
            top: 0,
            bottom: 0,
            left: 0,
          },
        }}
        {...props}
      >
        {children}
      </Stack>
    </Card>
  );
};
